module.exports = "<p>\n  running works!\n</p>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/running/running.component.html
// module id = ./src/app/running/running.component.html
// module chunks = main